"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultStyleSheet = exports.defaultStyleSheetRootDir = void 0;
exports.defaultStyleSheetRootDir = "styles";
exports.defaultStyleSheet = "site.css";
//# sourceMappingURL=defaults.js.map